/* @ngInject */
function ManageAssetsTabController ($scope, AdminService, UserService, ToastService) {
  $scope.companyDesignerOptions = []
  $scope.designersPagination = {
    top: 10,
    skip: 0
  }

  const api = {
    _getCompanyDesignerOptions
  }
  this.getApi = () => api

  activate()

  function activate () {
    api._getCompanyDesignerOptions()
  }

  $scope.onChangeRestrictAccess = event => {
    const value = event?.detail?.value
    $scope.flags.restrictAccess = !!value
    $scope.flags.applySegmentationToAllAssets = false

    $scope.form.selectedDesigners = $scope.flags.restrictAccess ? $scope.flags.designersToShow : []

    $scope.flags.hasSave = !$scope.flags.hasSameSegmentation && $scope.flags.restrictAccess
  }

  function _getCompanyDesignerOptions (search = '', firstLoad = false) {
    AdminService.getUsers($scope.designersPagination.top, $scope.designersPagination.skip, { role: ['DESIGNER'], active: true, search })
      .then(users => {
        const mappedUsers = users.d.results
          .map(user => {
            return {
              url: user.profileImageId ? UserService.getUserProfileImage(user.id) : null,
              value: user.id,
              label: user.name
            }
          })

        $scope.companyDesignerOptions = firstLoad ? mappedUsers : $scope.companyDesignerOptions.concat(mappedUsers)
        $scope.hasMoreDesignersToLoad = users.d.__count > $scope.companyDesignerOptions.length
      })
      .catch(() => {
        ToastService.defaultErrorToast()
      })
  }

  $scope.onSearchDesigners = event => {
    const search = event?.detail?.search || ''
    $scope.designersPagination.skip = 0

    api._getCompanyDesignerOptions(search, true)
  }

  $scope.onInfiniteLoadDesigners = event => {
    const search = event?.detail?.search || ''
    $scope.designersPagination.skip += $scope.designersPagination.top

    api._getCompanyDesignerOptions(search, false)
  }

  $scope.onChangeDesigners = event => {
    $scope.flags.hasSave = false
    const changedDesigners = event?.detail

    $scope.form.selectedDesigners = changedDesigners
  }

  $scope.changeApplySegmentationToAllAssets = event => {
    const value = event?.detail?.value
    $scope.flags.applySegmentationToAllAssets = !!value

    $scope.flags.hasSave = !$scope.flags.applySegmentationToAllAssets
  }
}

export { ManageAssetsTabController }
